import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ServiciosService } from '../../services/servicios.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-rellamada',
  templateUrl: './rellamada.component.html',
  styleUrls: ['./rellamada.component.scss'],
})
export class RellamadaComponent implements OnInit {
  public formData:FormGroup;
  public lastNumber:number;
  constructor(@Inject(MAT_DIALOG_DATA) private data,private _fb:FormBuilder,public _servicios:ServiciosService) {
    this.formData = this._fb.group({
      consecutivo:[this.data.csc],
      rellamadas:this._fb.array([
      ])
    });
    this._servicios.rellamadasOfAService(data.csc).subscribe(rellamadas=>{
      this.lastNumber = rellamadas.length;
      rellamadas.map(rellamada=>{
        this.addGroupRecall(rellamada.responsableLlamada,rellamada.observacion,rellamada.id_operador,rellamada.fecha_llamada,rellamada.nombre_operador)
      })
      if(this.data.csc != null){
        this.addGroupRecall();  
      }
    })
  }

  ngOnInit() {
  }

  public createGroupRecall(responsable?:string,observacion?:string,id_operador?:string,fecha?,nombre_operador?){
    return this._fb.group({
      responsableLlamada:[{value:'' || responsable,disabled:!!fecha},Validators.required],
      observacion:[{value:'' || observacion,disabled:!!fecha},Validators.required],
      id_operador:[id_operador || JSON.parse(localStorage.getItem("usuario")).id_usuario  ],
      fecha:['' || fecha],
      nombre_operador:[nombre_operador || JSON.parse(localStorage.usuario).nombre]
    })
  }
  
  get listRecall():FormArray{
    return this.formData.get('rellamadas') as FormArray;
  }

  public addGroupRecall(responsable?:string,observacion?:string,id_operador?:string,fecha?,nombre_operador?:string){
    this.listRecall.push(this.createGroupRecall(responsable,observacion,id_operador,fecha,nombre_operador));
  }
  enviar(){
    // console.log(this.formData.value);
    this._servicios.nuevasRellamadas(this.formData.value).subscribe(succ=>{
      console.log(succ)
    })
  }
}